// extracted by mini-css-extract-plugin
export var legendIndicator = "_b9-1";
export var legendRight = "_b9-0";